import { Button, Icon } from "@astrum/ui";
import { useAuth } from "../lib/auth.js";
import { usePageTitle } from "../lib/usePageTitle.js";
import { TwoFactorSetup } from "./Profile.js";
import "./change-password.css";
import "./profile.css";

/**
 * The screen a person lands on when the workspace requires two-factor
 * authentication and they have not enrolled yet. Like a forced password change
 * it replaces the app: the API refuses everything else (TWO_FACTOR_REQUIRED)
 * until enrolment is done, so there is nowhere else to go.
 */
export function TwoFactorRequired() {
  usePageTitle("Set up two-factor");
  const { refresh, signOut } = useAuth();

  return (
    <div className="change-password change-password--forced">
      <div className="change-password__card">
        <div className="change-password__brand">
          <Icon name="lock" size={22} />
          <h1>Set up two-factor authentication</h1>
        </div>
        <p className="change-password__muted">
          Your workspace requires two-factor authentication. Set it up now to carry on — it takes about a minute.
        </p>
        {/* Cancelling is signing out: there is no other screen to fall back to. */}
        <TwoFactorSetup onEnabled={() => void refresh()} onClose={() => void signOut()} />
        <Button variant="ghost" size="sm" onClick={() => void signOut()}>
          Sign out instead
        </Button>
      </div>
    </div>
  );
}
